import React, { useRef, useEffect } from "react";

import { orderBy } from "lodash";

import { Container, Box, Flex } from "@chakra-ui/react";

import { Section } from "../../../../graphql/generated/definitions";
import useStore from "../../../../store";

import { SectionOrderPill } from "./SectionOrderPill";

const SectionNavigationHeader: React.FC<{
  sections?: Pick<Section, "title" | "order" | "id">[];
}> = ({ sections }) => {
  const containerRef = useRef<HTMLDivElement>();
  const sectionsLabelRef = useRef<HTMLDivElement[]>(
    Array.from({ length: sections?.length })
  );
  const [currentSectionId, shouldScroll] = useStore(
    (state) => state.report.currentSectionState
  );
  const setCurrentSectionState = useStore(
    (state) => state.report.setCurrentSectionState
  );

  useEffect(() => {
    const activeSection = sectionsLabelRef.current.find(
      (ref) => ref?.id === `${currentSectionId}-header-pill`
    );

    if (!activeSection || !containerRef.current) return;

    if (shouldScroll)
      document.getElementById(currentSectionId)?.scrollIntoView();

    const ELEMENT_PADDING = 16;

    const containerWidth = containerRef.current.offsetWidth;
    const sectionWidth = activeSection.offsetWidth;

    const containerMargin = parseInt(
      window?.getComputedStyle(containerRef.current.parentElement)
        ?.marginInlineStart || "0"
    );

    const leftPosition =
      activeSection.offsetLeft - containerMargin - ELEMENT_PADDING;

    let scrollToLeftValue = 0;

    if (sectionWidth > containerWidth) scrollToLeftValue = leftPosition;
    else scrollToLeftValue = leftPosition - (containerWidth - sectionWidth) / 2;

    containerRef.current.scrollTo({
      left: scrollToLeftValue,
      behavior: "smooth",
    });
  }, [currentSectionId, shouldScroll]);

  return (
    <Box bgColor="brand" boxShadow="md">
      <Container
        display="flex"
        justify="center"
        maxW="container.xl"
        overflowX="hidden"
      >
        <Flex
          ref={containerRef}
          overflowX="auto"
          mx="auto"
          experimental_spaceX="4"
          userSelect="none"
          sx={{
            scrollbarWidth: "none",
            "::-webkit-scrollbar": { display: "none" },
          }}
        >
          {orderBy(sections, "order")?.map(({ title, order, id }, index) => (
            <Flex
              ref={(el) => (sectionsLabelRef.current[index] = el)}
              cursor="pointer"
              id={`${id}-header-pill`}
              key={index}
              align="center"
              flex="0 0 auto"
              py={["4", "2"]}
            >
              <Flex align="center" onClick={() => setCurrentSectionState(id, true)}>
                <SectionOrderPill active={id === currentSectionId}>
                  {order + 1}
                  {". "}
                  {title}
                </SectionOrderPill>
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Container>
    </Box>
  );
};

export default SectionNavigationHeader;
